import { render, staticRenderFns } from "./OnlinePie.vue?vue&type=template&id=3b67bbc0&scoped=true&"
import script from "./OnlinePie.vue?vue&type=script&lang=js&"
export * from "./OnlinePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b67bbc0",
  null
  
)

export default component.exports